module.exports = __webpack_public_path__ + "static/img/img-product-no-data.5b2374cc.png";